// import { useState } from "react";
// import "./medical-dashboard.css";
// import ScheduleUpdateModal from "../modals/ScheduleUpdateModal";
// import DeclineModal from "../modals/DeclineModal";
// import { get, post } from "../../utility/fetchWeb";
// import notification from "../../utility/notification";
// import { useNavigate } from "react-router-dom";
// import ZoomMeeting from "./ZoomMeeting";
// const userInfo = JSON.parse(localStorage.getItem("USER_INFO"));

// const generateDateRange = () => {
//   const today = new Date();
//   const dates = [];

//   // Start from 7 days ago
//   for (let i = -7; i <= 7; i++) {
//     const date = new Date(today);
//     date.setDate(today.getDate() + i);

//     dates.push({
//       date: date.getDate(),
//       day: date.toLocaleDateString("en-US", { weekday: "short" }).toUpperCase(),
//       fullDate: date, // Keep full date for comparison
//     });
//   }

//   return dates;
// };

// const ZoomPage = ({ data }) => {
//   const [isDrawerOpen, setIsDrawerOpen] = useState(false);
//   // Initialize selectedDate with today's date
//   const [selectedDate, setSelectedDate] = useState(new Date().getDate());
//   const [selectedSchedule, setSelectedSchedule] = useState(null);
//   const [zoomData, setzoomData] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isNewSchedule, setIsNewSchedule] = useState(false);
//   const [patientData, setPatientData] = useState([]);
//   const [isDeclineModalOpen, setIsDeclineModalOpen] = useState(false);
//   const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
//   const [singleAppointmentData, setsingleAppointmentData] = useState(null);
//   const [slots, setSlots] = useState([]);
//   const [credentials, setcredentials] = useState([]);
//   const doctorId = sessionStorage.getItem("userId");

//   // Generate dynamic dates
//   const dates = generateDateRange();

//   const navigate = useNavigate();

//   const scheduleData = [
//     { id: 0, day: "Monday", period: "1:00pm - 3:00pm", patients: 3 },
//     { id: 1, day: "Tuesday", period: "1:00pm - 3:00pm", patients: 3 },
//     { id: 2, day: "Wednesday", period: "1:00pm - 3:00pm", patients: 3 },
//     { id: 3, day: "Thursday", period: "11:00am - 1:00pm", patients: 3 },
//     { id: 4, day: "Friday", period: "11:00am - 1:00pm", patients: 3 },
//     { id: 5, day: "Saturday", period: "2:00pm - 4:00pm", patients: 3 },
//     { id: 6, day: "Sunday", period: "2:00pm - 4:00pm", patients: 3 },
//   ];

//   const getWaiting = async () => {
//     try {
//       // const data = await get(`/Appointment/doctor/${doctorId}`);
//       const data = await get(
//         `/Appointment/all-appointments-by-doctor/${userInfo.userId}?pageNumber=1&pageSize=100`
//       );
//       // setPatientData(data.data || []);

//       console.log("Waiting patients: ", data);
//       // if (data?.status === "success") {
//       //   // Filter for pending appointments only
//       const pendingAppointments = data?.data;
//       // ?
//       // .filter(
//       //   (appointment) => appointment.statusText?.toLowerCase() === "pending"
//       // );
//       setPatientData(pendingAppointments || []);
//       // } else {
//       //   setPatientData([]);
//       // }
//     } catch (e) {
//       console.log("Error: ", e);
//       setPatientData([]);
//     }
//   };

//   const getWaitingSingle = async (id) => {
//     try {
//       // const data = await get(`/Appointment/doctor/${doctorId}`);
//       const data = await get(`/Appointment/${id}`);
//       // setPatientData(data.data || []);
//       setsingleAppointmentData(data?.data);
//       console.log("Waiting patients: ", data);
//       // if (data?.status === "success") {
//       //   // Filter for pending appointments only
//       // const pendingAppointments = data?.data;
//       // ?
//       // .filter(
//       //   (appointment) => appointment.statusText?.toLowerCase() === "pending"
//       // );
//       // setPatientData(pendingAppointments || []);
//       // } else {
//       //   setPatientData([]);
//       // }
//     } catch (e) {
//       console.log("Error: ", e);
//       setPatientData([]);
//     }
//   };

//   const getSlots = async () => {
//     try {
//       const data = await get(
//         `/Doctors/api/slots/availableByDoctorId?doctorId=${doctorId}`
//       );
//       console.log("Waiting slots: ", data);
//       if (data.length > 0) {
//         setSlots(data);
//       } else {
//         setSlots([]);
//       }
//     } catch (e) {
//       console.log("Error: ", e);
//       setSlots([]);
//     }
//   };

//   useState(() => {
//     getWaiting();
//     // getWaitingSingle();
//     getSlots();
//   }, []);

//   const toggleDrawer = () => {
//     setIsDrawerOpen(!isDrawerOpen);
//   };

//   const getStatusColor = (appointment) => {
//     if (appointment.isCanceled || appointment.statusText == "Declined")
//       return "#ff6b6b";
//     if (appointment.statusText == "Pending") return "#4B8AFF";
//     if (appointment.isAdmitted) return "#4ecdc4";
//     return "#51cf66";
//   };

//   const getStatusText = (appointment) => {
//     if (appointment.isCanceled) return "Canceled";
//     else if (appointment.isAdmitted) return "Admitted";
//     else return appointment?.statusText;
//   };

//   const handleScheduleClick = (schedule) => {
//     setSelectedSchedule(schedule);
//     setIsNewSchedule(false);
//     setIsModalOpen(true);
//   };

//   const handleCreateNewSchedule = () => {
//     setSelectedSchedule({});
//     setIsNewSchedule(true);
//     setIsModalOpen(true);
//   };

//   const handleAcceptAppointment = async (appointmentId) => {
//     try {
//       const response = await post(
//         `/Appointment/appointments/${appointmentId}/accept-appointment`
//       );
//       if (response.message === "Appointment accepted.") {
//         notification({
//           title: "Success",
//           message: "Appointment accepted successfully",
//           type: "success",
//         });
//         getWaiting(); // Refresh the appointments list
//         getWaitingSingle(appointmentId); // Refresh the appointments list
//       }
//     } catch (error) {
//       notification({
//         title: "Error",
//         message: "Failed to accept appointment",
//         type: "error",
//       });
//       console.error("Error accepting appointment:", error);
//     }
//   };

//   const handleDeclineAppointment = async (appointmentId, reason) => {
//     try {
//       const response = await post(
//         `/Appointment/appointments/${appointmentId}/decline`,
//         {
//           reason: reason,
//         }
//       );

//       if (response.message === "Appointment declined and notifications sent.") {
//         notification({
//           title: "Success",
//           message: "Appointment declined successfully",
//           type: "success",
//         });
//         getWaiting();
//         getWaitingSingle(appointmentId); // Refresh the appointments list
//         // Refresh the appointments list
//       }
//     } catch (error) {
//       notification({
//         title: "Error",
//         message: "Failed to decline appointment",
//         type: "error",
//       });
//       console.error("Error declining appointment:", error);
//     } finally {
//       setIsDeclineModalOpen(false);
//       setSelectedAppointmentId(null);
//     }
//   };

//   function parseZoomLinkFunction(zoomLink) {
//     try {
//       const url = new URL(zoomLink);

//       // Extract basic URL components
//       const protocol = url.protocol;
//       const hostname = url.hostname;
//       const port = url.port || null;
//       let pathname = url.pathname;
//       const search = url.search;
//       const hash = url.hash || null; // Fragment identifier

//       // Extract the value after '/s/' in the pathm
//       const pathSegments = pathname.split("/");
//       let sValue = null;
//       if (pathSegments.length > 2 && pathSegments[1] === "s") {
//         sValue = pathSegments[2];
//       }

//       // Extract the 'zak' query parameter
//       const zak = url.searchParams.get("zak");

//       // Attempt to decode the JWT payload of the 'zak' token (client-side decoding)
//       let decodedZakPayload = null;
//       if (zak) {
//         try {
//           const parts = zak.split(".");
//           // JWTs have three parts: header.payload.signature
//           if (parts.length === 3) {
//             // The payload is base64url encoded. window.atob is for standard base64.
//             // For base64url, you might need to adjust characters.
//             // A safer way for base64url is to replace non-standard chars for window.atob
//             let base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
//             // Pad with '=' if necessary
//             while (base64.length % 4) {
//               base64 += "=";
//             }
//             decodedZakPayload = JSON.parse(window.atob(base64));
//           }
//         } catch (jwtError) {
//           console.warn(
//             "Could not decode zak JWT payload (client-side):",
//             jwtError.message
//           );
//           decodedZakPayload = "Error decoding JWT or invalid format";
//         }
//       }

//       function removeFirstThreeSubstring(word) {
//         // Start extracting from index 3 (the fourth character) to the end of the string.
//         return word.substring(3);
//       }
//       // Collect all extracted parts into an object
//       if (pathname.startsWith("/s/")) {
//         // alert("true");
//         pathname = removeFirstThreeSubstring(pathname);
//       }
//       // If pathname is now an empty string, set it to '/' for consistency if needed,
//       // though for Zoom links like this, it will likely be empty.
//       if (pathname === "") {
//         pathname = "/";
//       }
//       return {
//         originalLink: zoomLink,
//         protocol: protocol,
//         hostname: hostname,
//         port: port,
//         pathname: pathname,
//         sValue: sValue, // The value after /s/ (e.g., '88587679837' which is likely the meeting ID)
//         queryParams: Object.fromEntries(url.searchParams.entries()), // All query parameters as an object
//         zak: zak, // The raw zak token
//         decodedZakPayload: decodedZakPayload, // Decoded JWT payload (if valid)
//         hash: hash,
//       };
//     } catch (error) {
//       console.error("Failed to parse Zoom link:", error.message);
//       return {
//         error: "Invalid URL provided",
//         details: error.message,
//       };
//     }
//   }

//    function extractZoomCredentialsPass(url) {
//     try {
//       const meetingNumber = url.match(/\/j\/(\d+)/)?.[1] || null;
//       const password = url.match(/[?&]pwd=([^&]+)/)?.[1] || null;

//       return {
//         meetingNumber,
//         password,
//         isValid: !!meetingNumber,
//       };
//     } catch (error) {
//       return {
//         meetingNumber: null,
//         password: null,
//         isValid: false,
//       };
//     }
//   };

//   // Update the formatTime function to include date
//   const formatTime = (dateString) => {
//     const date = new Date(dateString);
//     return {
//       date: date.toLocaleDateString("en-US", {
//         month: "short",
//         day: "numeric",
//         year: "numeric",
//       }),
//       time: date.toLocaleTimeString("en-US", {
//         hour: "2-digit",
//         minute: "2-digit",
//         hour12: true,
//       }),
//     };
//   };

//   return (
//     <div className="w-100">
//       {/* Main Content */}
//       <div className="main-content">
//         {/* Header */}
//         <div className="header">
//           <div className="search-bar">
//             <input type="text" placeholder="Search appointments" />
//           </div>
//           <div className="header-actions">
//             <button className="manage-schedule-btn" onClick={toggleDrawer}>
//               ← Manage My Schedule
//             </button>
//           </div>
//         </div>
//         {/* Doctor Info */}
//         <div className="doctor-info">
//           <div className="doctor-avatar">
//             <img src="/user-avater.png" alt="Doctor" />
//           </div>
//           <div className="doctor-details">
//             <p className="greeting">Good Day</p>
//             <h2 className="doctor-name">Dr. Ember Wynn</h2>
//             <p className="hospital">Healing Stripes Hospital, Lagos.</p>
//           </div>
//         </div>
//         {/* Bookings Summary */}
//         <div className="bookings-summary">
//           <div className="summary-card">
//             <span>Total Bookings for this month</span>
//             <span className="booking-count">25</span>
//           </div>
//         </div>
//         {/* Date Selection */}
//         <div className="date-section">
//           <h3>Select Date</h3>
//           <div className="date-picker">
//             {dates.map((dateItem) => (
//               <div
//                 key={dateItem.fullDate.toISOString()}
//                 className={`date-item ${
//                   selectedDate === dateItem.date ? "selected" : ""
//                 } ${
//                   dateItem.fullDate.toDateString() === new Date().toDateString()
//                     ? "today"
//                     : ""
//                 }`}
//                 onClick={() => setSelectedDate(dateItem.date)}
//               >
//                 <span className="date-number">{dateItem.date}</span>
//                 <span className="date-day">{dateItem.day}</span>
//               </div>
//             ))}
//           </div>
//         </div>{" "}
//         {/* Appointments List */}
//         <div style={{ display: "flex" }}>
//           <div className="appointments-section w-40">
//             <div className="appointments-list">
//               {patientData?.length > 0 ? (
//                 patientData.map((appointment) => (
//                   <div>
//                     <div class="appointment-card2">
//                       <img
//                         src="/user-avater.png"
//                         alt="Doctor"
//                         class="appointment-card__image"
//                       />
//                       <div class="appointment-card__details">
//                         <div class="appointment-card__header">
//                           <p class="appointment-card__name">
//                             {appointment.patientName}
//                           </p>
//                           <span
//                             style={{
//                               backgroundColor: getStatusColor(appointment),
//                             }}
//                             class="appointment-card__status appointment-card__status-no-show status-badge"
//                           >
//                             {getStatusText(appointment)}
//                           </span>
//                         </div>
//                         <div class="appointment-card__symptom">
//                           <span class="appointment-card__symptom-indicator"></span>
//                           <p class="appointment-card__symptom-text">
//                             {appointment.description}
//                           </p>
//                         </div>
//                         <p class="appointment-card__time-booking">
//                           {appointment.appointTime} | Online Booking
//                         </p>
//                       </div>
//                       <span
//                         onClick={() => {
//                           setcredentials(extractZoomCredentialsPass(appointment.zoomJoinUrl))
//                           setzoomData(
//                             parseZoomLinkFunction(appointment.zoomStartUrl)
//                           );
//                           console.log(
//                             parseZoomLinkFunction(appointment.zoomStartUrl)
//                           );
//                           setsingleAppointmentData(appointment);
//                         }}
//                         class="appointment-card__arrow"
//                       >
//                         &gt;
//                       </span>
//                     </div>
//                     {/* <div key={appointment.id} className="appointment-card2">
//                       <div className="patient-avatar">
//                         <img
//                           src="/user-avater.png"
//                           alt={appointment.patientName}
//                         />
//                       </div>
//                       <div className="appointment-details">
//                         <div className="patient-info">
//                           <h4>{appointment.patientName}</h4>
//                           <div className="appointment-meta">
//                             <span className="appointment-time">
//                               {appointment.appointTime}
//                             </span>
//                             <span className="appointment-type">
//                               {appointment.description}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="flex gap-8 flex-v-center">
//                         <div className="appointment-status">
//                           <span
//                             className="status-badge"
//                             style={{
//                               backgroundColor: getStatusColor(appointment),
//                             }}
//                           >
//                             {getStatusText(appointment)}
//                           </span>
//                         </div>
//                         <div className="appointment-actions">
//                           <button
//                             onClick={() => {
//                               localStorage.setItem(
//                                 "appointmentId",
//                                 appointment.id
//                               );
//                               navigate(
//                                 `/patients/patient-details/${appointment.patientId}`
//                               );
//                             }}
//                             className="action-btn"
//                           >
//                             View Profile
//                           </button>
//                           {appointment.statusText === "Pending" && (
//                             <>
//                               <button
//                                 className="action-btn accept-btn m-r-10 m-l-10"
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleAcceptAppointment(appointment.id);
//                                 }}
//                               >
//                                 Accept
//                               </button>
//                               <button
//                                 className="action-btn decline-btn"
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   setSelectedAppointmentId(appointment.id);
//                                   setIsDeclineModalOpen(true);
//                                 }}
//                               >
//                                 Decline
//                               </button>
//                             </>
//                           )}
//                         </div>
//                       </div>
//                     </div> */}
//                   </div>
//                 ))
//               ) : (
//                 <div className="no-appointments">
//                   <p>No pending appointments found</p>
//                 </div>
//               )}
//             </div>
//           </div>
//           {singleAppointmentData && (
//             <div class="booking-form-container w-60 flex">
//               <div class="booking-profile-section">
//                 <img
//                   src="/user-avater.png"
//                   alt="Doctor"
//                   class="booking-profile-image"
//                 />
//                 {/* <img src="your-image-path.png" alt="Profile of Goodness Chibueze" class="booking-profile-image"> */}
//                 <h2 class="booking-profile-name">
//                   {singleAppointmentData?.patientName}
//                 </h2>
//                 <div class="booking-profile-date-time">
//                   <span class="booking-profile-date">April 16, 2023</span> |{" "}
//                   <span class="booking-profile-time">12:30pm</span>
//                 </div>
//                 <p class="booking-profile-status">
//                   <span
//                     style={{
//                       backgroundColor: getStatusColor(singleAppointmentData),
//                     }}
//                     class="appointment-card__status appointment-card__status-no-show status-badge"
//                   >
//                     {getStatusText(singleAppointmentData)}
//                   </span>
//                   {/* {singleAppointmentData?.statusText} */}
//                 </p>
//               </div>
//               <div class="booking-form-fields">
//                 <div class="booking-form-group">
//                   <label for="ageBracket" class="booking-form-label">
//                     Age Bracket
//                   </label>
//                   <input
//                     type="text"
//                     id="ageBracket"
//                     value="25 - 30"
//                     class="booking-form-input"
//                     readonly
//                   />
//                 </div>
//                 <div class="booking-form-group">
//                   <label for="gender" class="booking-form-label">
//                     Gender
//                   </label>
//                   <input value={""} class="booking-form-input" />
//                   {/* <select id="gender" class="booking-form-select">
//                   <option value="">Select Option</option>
//                 </select> */}
//                 </div>
//                 <div class="booking-form-group">
//                   <label for="consultReason" class="booking-form-label">
//                     Why would you like to consult
//                   </label>
//                   <input value={""} class="booking-form-input" />

//                   {/* <select id="consultReason" class="booking-form-select">
//                   <option value="">Select Option</option>
//                 </select> */}
//                 </div>
//                 <div class="booking-form-group">
//                   <label for="whyDrWynn" class="booking-form-label">
//                     Why would you like to see Dr. Wynn?
//                   </label>
//                   <textarea
//                     id="whyDrWynn"
//                     class="booking-form-textarea"
//                     value={singleAppointmentData?.description}
//                   ></textarea>
//                 </div>

//                 {singleAppointmentData?.statusText === "Pending" && (
//                   <div>
//                     <button
//                       disabled={singleAppointmentData?.statusText !== "Pending"}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleAcceptAppointment(singleAppointmentData?.id);
//                       }}
//                       class="booking-form-button booking-form-button--accept"
//                     >
//                       Accept Booking
//                     </button>
//                     <button
//                       disabled={singleAppointmentData?.statusText !== "Pending"}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setSelectedAppointmentId(singleAppointmentData?.id);
//                         setIsDeclineModalOpen(true);
//                       }}
//                       class="booking-form-button booking-form-button--reject"
//                     >
//                       Reject Booking
//                     </button>
//                   </div>
//                 )}
//                 <div class="booking-health-record-status">
//                   <button class="booking-health-record-button">
//                     Health Record Not Available
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Schedule Management Drawer */}
//       <div
//         className={`drawer-overlay ${isDrawerOpen ? "open" : ""}`}
//         onClick={toggleDrawer}
//       ></div>
//       <div className={`schedule-drawer ${isDrawerOpen ? "open" : ""}`}>
//         <div className="drawer-header">
//           <button className="close-btn" onClick={toggleDrawer}>
//             ←
//           </button>
//           <h3>Manage My Schedule</h3>
//         </div>

//         <div className="schedule-table">
//           <div className="table-header2">
//             <div className="header-cell">Date</div>
//             <div className="header-cell">Start Time</div>
//             <div className="header-cell">End Time</div>
//             <div className="header-cell">Status</div>
//           </div>

//           {slots?.map((slot, index) => {
//             const startDateTime = formatTime(slot.startTimeUtc);
//             const endDateTime = formatTime(slot.endTimeUtc);

//             return (
//               <div
//                 key={slot.id || index}
//                 className="table-row2"
//                 onClick={() => handleScheduleClick(slot)}
//               >
//                 <div className="cell">{startDateTime.date}</div>
//                 <div className="cell">{startDateTime.time}</div>
//                 <div className="cell">{endDateTime.time}</div>
//                 <div className="cell">
//                   <span
//                     className={`status-indicator ${
//                       slot.isBooked ? "booked" : "available"
//                     }`}
//                   >
//                     {slot.isBooked ? "Booked" : "Available"}
//                   </span>
//                 </div>
//               </div>
//             );
//           })}
//         </div>

//         <button
//           className="update-schedule-btn"
//           onClick={handleCreateNewSchedule}
//         >
//           Create New Schedule
//         </button>
//       </div>

//       <ScheduleUpdateModal
//         isOpen={isModalOpen}
//         onClose={() => {
//           setIsModalOpen(false);
//           setIsNewSchedule(false);
//         }}
//         schedule={selectedSchedule || {}}
//         isNewSchedule={isNewSchedule}
//       />
//       <DeclineModal
//         isOpen={isDeclineModalOpen}
//         onClose={() => {
//           setIsDeclineModalOpen(false);
//           setSelectedAppointmentId(null);
//         }}
//         onDecline={(reason) =>
//           handleDeclineAppointment(selectedAppointmentId, reason)
//         }
//       />

//       {zoomData && (
//         // <ZoomMeeting
//         //   sdkKey={process.env.REACT_APP_ZOOM_SDK_KEY}
//         //   // signature={zoomSignature}
//         //   meetingNumber={zoomData?.pathname}
//         //   // password={zoomMeetingPassword}
//         //   role={1}
//         //   zak={zoomData?.zak}
//         //   userName={userInfo.firstName}
//         //   userEmail={'greenzone@yahoo.com'}
//         // />

//         <ZoomMeeting
//           meetingNumber={zoomData?.pathname}
//           userName={userInfo?.firstName}
//           userEmail={"greenzone@yahoo.com"} // Provide the host's email
//           zak={zoomData?.zak}
//           password={credentials?.password}
//           role={1} // Set role to HOST (1)
//         />
//       )}
//     </div>
//   );
// };

// export default ZoomPage;

// {
//   /* <div class="appointment-card">
//     <img src="your-image-path.png" alt="Goodness Chibueze" class="appointment-card__image">
//     <div class="appointment-card__details">
//         <div class="appointment-card__header">
//             <p class="appointment-card__name">Goodness Chibueze</p>
//             <span class="appointment-card__status appointment-card__status--no-show">No Show</span>
//         </div>
//         <div class="appointment-card__symptom">
//             <span class="appointment-card__symptom-indicator"></span>
//             <p class="appointment-card__symptom-text">Heart Burn and Cough</p>
//         </div>
//         <p class="appointment-card__time-booking">10.30am | Online Booking</p>
//     </div>
//     <span class="appointment-card__arrow">&gt;</span>
// </div> */
// }

import React, { useEffect, useState } from "react";
import { Eye } from "lucide-react";
import "./ZoomPage.css";
import { useParams } from "react-router-dom";
import { get, post } from "../../utility/fetch2";
import AddTreatment from "../modals/AddTreatmentOld";
import ReferPatient from "../modals/ReferPatient";
import toast from "react-hot-toast";
import ReferToHospital from "../modals/ReferToHospital";
import SidePanelModal from "../modals/SlidePanelModal";
import VitalsRecords from "../modals/VitalsRecord";
import LabPatientComponent from "./lab/LabPatientComponent";
import PharmacyPatientComponent from "./PharmacyPatientComponent";

export default function ZoomPage({ setshowAll, singleAppointmentData }) {
  // Add missing state setters for SidePanelModal logic
  const [showtype, setshowtype] = useState(null);
  const [pushToOpen, setpushToOpen] = useState(false);
  const [vitals, setVitals] = useState(null);
  const [dataFromLab, setDataFromLab] = useState(null);
  const [dataFromLabProcessed, setDataFromLabProcessed] = useState(null);
  const [treatmentId, setTreatmentId] = useState(null);
  const { id } = useParams();

  const [treatmentModalHospital, setTreatmentModalHospital] = useState(false);
  const [treatmentModal, setTreatmentModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [repeatedDiagnosis, setRepeatedDiagnosis] = useState("");

  //   const [singleAppointmentData, setsingleAppointmentData] = useState(null);

  useEffect(() => {
    getWaitingSingle(singleAppointmentData.id);
    console.log(singleAppointmentData);
  }, [singleAppointmentData.id]);

  const toggleModal = () => {
    // if (lastVisit === null) {
    //   toast("A visit has to exist before you can refer patient");
    //   return;
    // }
    setShowModal(!showModal);
  };

  const toggleTreatmentModalHospital = () => {
    // if (lastVisit === null) {
    //   alert("");

    //   toast("A visit has to exist before you can add treatment");
    //   return;
    // }
    setTreatmentModalHospital(!treatmentModalHospital);
  };

  const toggleTreatmentModal = () => {
    // if (lastVisit === null) {
    //   alert("");

    //   toast("A visit has to exist before you can add treatment");
    //   return;
    // }
    setTreatmentModal(!treatmentModal);
  };

  const getWaitingSingle = async (id) => {
    try {
      // const data = await get(`/Appointment/doctor/${doctorId}`);
      const data = await get(`/Appointment/${id}`);
      // setPatientData(data.data || []);
      //   setsingleAppointmentData(data?.data);
      console.log("Waiting patients: ", data);
      // if (data?.status === "success") {
      //   // Filter for pending appointments only
      // const pendingAppointments = data?.data;
      // ?
      // .filter(
      //   (appointment) => appointment.statusText?.toLowerCase() === "pending"
      // );
      // setPatientData(pendingAppointments || []);
      // } else {
      //   setPatientData([]);
      // }
    } catch (e) {
      console.log("Error: ", e);
      //   setPatientData([]);
    }
  };

  const createTreatmet = async (load) => {
    let payload = {
      patientId: 0,
      dateOfVisit: "2025-07-07T15:43:00.852Z",
      age: "string",
      diagnosis: "string",
      treatmentStatus: 0,
      additionalNote: "string",
      isAdmitted: true,
      admittedHealthCareProviderId: 0,
      familyMedicineId: 0,
      oG_IVFId: 0,
      oG_BirthRecordId: 0,
      orthopedicId: 0,
      generalSurgeryId: 0,
      pediatricId: 0,
      generalPracticeId: 0,
      antenatalId: 0,
      cardiologyId: 0,
      doctorId: 0,
      appointmentId: 0,
      carePlan: "string",
      medications: [
        {
          pharmacyHealthCareProviderId: 0,
          referredPharmacyInventoryId: 0,
          drugStrengthUnit: 0,
          quantity: 0,
          administrationFrequency: 1,
          routeOfAdministration: 1,
          duration: 0,
          composite: true,
        },
      ],
      ...load,
    };
    console.log(payload);

    // return;

    // {
    //   dateOfVisit: "2025-05-01T05:09:59.302Z",
    //   appointmentId: +localStorage.getItem("appointmentId"),
    //   diagnosis: "string",
    //   isAdmitted: false,
    //   // patientId: +patientId,
    //   medications: [
    //     {
    //       pharmacyInventoryId: 1,
    //       quantity: 1,
    //       frequency: 2,
    //       duration: 0,
    //     },
    //   ],
    //   otherMedications: [
    //     // {
    //     //   name: "fhhkjkkkhk",
    //     //   quantity: 0,
    //     //   frequency: 0,
    //     //   duration: 0,
    //     // },
    //   ],
    //   followUpAppointment: {
    //     id: 0,
    //     appointDate: "1920/09/1",
    //     appointTime: "23:09",
    //     description: "string",
    //     doctorEmployeeId: 0,
    //     nurseEmployeeId: 0,
    //     isAdmitted: true,
    //     patientId: 0,
    //     serviceId: 0,
    //     isEmergency: true,
    //     careType: 0,
    //   },
    //   carePlan: "string",
    //   familyMedicineId: 0,
    //   oG_IVFId: 0,
    //   oG_BirthRecordId: 0,
    //   orthopedicId: 0,
    //   generalSurgeryId: 0,
    //   pediatricId: 0,
    //   // generalPracticeId: +treatmentId || 0,
    //   antenatalId: 0,
    //   ...load,
    // };

    // return;

    try {
      await post(`/treatment`, payload);
      // await fetchData();
      toast.success("Treatment added successfully");
      // closeModal();
      toggleTreatmentModal();
    } catch (error) {
      toast.error("Error adding treatment");
      console.log(error);
    }
  };

  // appointmentId
  return (
    <div className="page-container w-100">
      {/* Top Bar */}
      <div className="top-bar">
        {/* <div className="top-actions">
          <button className="primary-btn">Activate AI Assistance</button>
          <button className="secondary-btn">View Patient's Records</button>
        </div> */}
        <div className="profile-image">
          <img src="https://via.placeholder.com/100" alt="Doctor" />
        </div>
      </div>

      {/* Body */}
      <div className="main-body">
        {/* Left Side */}
        <div className="left-panel">
          <button
            onClick={() => {
              setshowAll(null);
              //   alert();
            }}
            className="back-arrow"
          >
            ←
          </button>
          <div className="text-area"></div>
        </div>

        {/* Right Side */}
        <div className="zoom-right-panel">
          {/* <button className="primary-btn full-width">Admit Patient</button> */}
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <button
                onClick={() => toggleTreatmentModal()}
                className="secondary-btn full-width"
                style={{ flex: 1 }}
              >
                Send Prescriptions
              </button>
              <Eye
                style={{ cursor: "pointer" }}
                size={22}
                onClick={() => {
                  setshowtype("treatment");
                  setpushToOpen(true);
                }}
                title="View Prescriptions"
              />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <button
                onClick={() => toggleModal()}
                className="secondary-btn full-width"
                style={{ flex: 1 }}
              >
                Request Lab Works
              </button>
              <Eye
                style={{ cursor: "pointer" }}
                size={22}
                onClick={() => {
                  setshowtype("lab");
                  setpushToOpen(true);
                }}
                title="View Lab Works"
              />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <button
                onClick={() => toggleTreatmentModalHospital()}
                className="secondary-btn full-width"
                style={{ flex: 1 }}
              >
                Refer Patient to Hospital
              </button>
              {/* <Eye
                style={{ cursor: "pointer" }}
                size={22}
                onClick={() => setshowtype("vitals")}
                title="View Vitals"
              /> */}
            </div>
          </div>
        </div>
      </div>

      {showtype && (
        <SidePanelModal
          showtype={showtype}
          pushOpen={pushToOpen}
          setpushToOpen={setpushToOpen}
          MyComponent={
            showtype == "vitals" ? (
              <VitalsRecords vitals={vitals} />
            ) : showtype == "lab" ? (
              <LabPatientComponent
                appointmentId={singleAppointmentData.id}
                data={dataFromLab}
                dataProcessed={dataFromLabProcessed}
              />
            ) : showtype == "treatment" ? (
              <PharmacyPatientComponent
                serviceId={treatmentId}
                serviceType={"generalPractice"}
                appointmentId={singleAppointmentData.id}
              />
            ) : (
              ""
            )
          }
        />
      )}

      {/* Voice Button */}
      {/* <div className="voice-control">
        <button className="mic-btn">🎤</button>
        <span className="time-label">23:09</span>
      </div> */}
      {treatmentModal && (
        <AddTreatment
          createTreatment={createTreatmet}
          repeatedDiagnosis={repeatedDiagnosis}
          setRepeatedDiagnosis={setRepeatedDiagnosis}
          closeModal={toggleTreatmentModal}
          id={singleAppointmentData.patientId}
          visit={singleAppointmentData}
          // visit={lastVisit}
          // data={data}
          // id={patientId}
          // fetchData={fetchData}
        />
      )}

      {treatmentModalHospital && (
        <ReferToHospital
          createTreatment={createTreatmet}
          repeatedDiagnosis={repeatedDiagnosis}
          setRepeatedDiagnosis={setRepeatedDiagnosis}
          closeModal={toggleTreatmentModalHospital}
          singleAppointmentData={singleAppointmentData}
          // data={data}
          id={singleAppointmentData.patientId}
          visit={singleAppointmentData}
          //   id={singleAppointmentData?.patientId}

          // fetchData={fetchData}
        />
      )}

      {showModal && (
        <ReferPatient
          repeatedDiagnosis={repeatedDiagnosis}
          setRepeatedDiagnosis={setRepeatedDiagnosis}
          closeModal={toggleModal}
          singleAppointmentData={singleAppointmentData}
          visit={singleAppointmentData.id}
          //   vital={vitals}
          //   generalPractice={+treatmentId || 0}
          // vitalId = {vitals.id}
          id={singleAppointmentData?.patientId}
          // treatment={data[0] || null}
        />
      )}
    </div>
  );
}
